import { render, staticRenderFns } from "./search_former.vue?vue&type=template&id=ec126b90&"
import script from "./search_former.vue?vue&type=script&lang=js&"
export * from "./search_former.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports